import { render, staticRenderFns } from "./Modal_Compra.vue?vue&type=template&id=802535e8&scoped=true"
import script from "./Modal_Compra.vue?vue&type=script&lang=js"
export * from "./Modal_Compra.vue?vue&type=script&lang=js"
import style0 from "./Modal_Compra.vue?vue&type=style&index=0&id=802535e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "802535e8",
  null
  
)

export default component.exports